import { dataFetcher, fileUploader } from 'core/services/requestHandler';   

const getProfileInfo = async (data = {}, config = {}) => {
  return dataFetcher('profile', data, {...config});
};

const updateProfile = async (data = {}, config = {}) => {
  return dataFetcher('update', data, {method: 'POST', ...config});
};

const changePassword = async (data = {}, config = {}) => {
  return dataFetcher('changePassword', data, {method: 'POST',...config});
};

const uploadProfilePhoto = async (data = {}, config = {}) => {
  return fileUploader('saveProfilePhoto', data, {...config});
};


export { getProfileInfo, updateProfile, changePassword, uploadProfilePhoto };
